import type { FC, FormHTMLAttributes, SyntheticEvent } from 'react';
import { memo, useRef } from 'react';
import useDetectAutofillMutation from './utils/useDetectAutofillMutation';

export interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
  onSubmit?: (event: SyntheticEvent) => void;
  onAutofill?: () => void;
}

const Form: FC<FormProps> = memo(({ onSubmit = () => {}, onAutofill, ...props }: FormProps) => {
  const formRef = useRef<HTMLFormElement>(null);

  useDetectAutofillMutation({ formRef, onAutofillDetected: onAutofill });

  return (
    <form
      ref={formRef}
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onSubmit(event);
      }}
      {...props}
    />
  );
});

export default Form;
